import apiRequest from './apiClient';

export const searchUsers = (query, organizationId, page = 0, size = 20, userId = null, hash = null, includeGuests = false) => {
  const params = new URLSearchParams({ query, page, size });
  if (organizationId != null) params.set('organizationId', organizationId);
  if (userId != null && hash != null) { params.set('userId', userId); params.set('hash', hash); }
  if (includeGuests) params.set('includeGuests', 'true');
  return apiRequest(`/api/users/search?${params}`);
};

const inlineParams = (userId, hash) =>
  userId && hash ? `?userId=${userId}&hash=${hash}` : '';

export const assignRole = (data, userId, hash) =>
  apiRequest(`/api/roles/assign${inlineParams(userId, hash)}`, {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const removeRole = (data, userId = null, hash = null) =>
  apiRequest(`/api/roles/remove${inlineParams(userId, hash)}`, {
    method: 'DELETE',
    body: JSON.stringify(data),
  });

export const generateInviteLink = (data, userId, hash) =>
  apiRequest(`/api/invite/generate${inlineParams(userId, hash)}`, {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const acceptInvite = (token) =>
  apiRequest('/api/invite/accept', {
    method: 'POST',
    body: JSON.stringify({ token }),
  });